export default {
    textDark2: '#262b3a',
    accent: '#7186e6',
    accentDart: 'rgba(113, 134, 230, 0.85)',
    textMiddle: '#697b8c',
    tab: '#159eff',
    red: '#fc3868'
}